import cx from 'classnames';
import {
    BZ2_SELLER_SEARCH_count_RESULT_REVIEWS,
    BZ2_SELLER_SEARCH_NO_RESULT_REVIEWS,
} from 'mk/autogenerated/translations/SellerCard.10c315e556693a35c0959b9840fe89b5'
import { SellerEntity } from 'mk2/apps/bazaar/schemas';
import { bazaarSellerReviewsFromBuyersUrl, bazaarSellerUrl } from 'mk2/apps/bazaar/urls';
import { AvatarImg } from 'mk2/components/AvatarImg';
import { Link } from 'mk2/components/Link';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import { Panel } from 'mk2/components/Panel';
import { url } from 'mk2/helpers/urls';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './SellerCard.mscss';

interface OwnProps {
    className?: string;
    seller: SellerEntity;
}

type Props = OwnProps;

class SellerCard extends React.Component<Props> {

    public shouldComponentUpdate(n: Props) {
        const p = this.props;
        return n.className !== p.className
            || n.seller.user !== p.seller.user
            || n.seller.productsCount !== p.seller.productsCount
            || n.seller.reviewsCount !== p.seller.reviewsCount
            || n.seller.location !== p.seller.location;
    }

    public render() {
        const { className, seller } = this.props;

        return (
            <Panel className={cx(styles.SellerCard, className)}>
                <AvatarImg
                    className={styles.SellerCard__avatar}
                    user={seller.user}
                    size={32}
                    href={url(bazaarSellerUrl, {username: seller.user.username})}
                />

                <div className={styles.SellerCard__info}>
                    <div className={styles.SellerCard__firstLine}>
                        <Link
                            className={styles.SellerCard__usernameAndProducts}
                            to={url(bazaarSellerUrl, {username: seller.user.username})}
                        >
                            <span className={styles.SellerCard__username}>{seller.user.username}</span>
                            {' '}
                            <span className={styles.SellerCard__products}>({seller.productsCount})</span>
                        </Link>

                        <Link
                            className={styles.SellerCard__reviews}
                            to={url(bazaarSellerReviewsFromBuyersUrl, {username: seller.user.username})}
                        >
                            {seller.reviewsCount
                                    ? interpolate(BZ2_SELLER_SEARCH_count_RESULT_REVIEWS, { count: seller.reviewsCount })
                                    : BZ2_SELLER_SEARCH_NO_RESULT_REVIEWS
                                }
                        </Link>
                    </div>

                    <Link
                        className={styles.SellerCard__location}
                        to={url(bazaarSellerUrl, {username: seller.user.username})}
                    >
                        {seller.location}
                    </Link>
                </div>
            </Panel>
        );
    }

}

export default SellerCard;

interface PlaceholderOwnProps {
    className?: string;
}

export const SellerCardPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ className }) => (
    <Panel className={cx(styles.SellerCard, className)}>
        <div className={styles.SellerCard__avatar}>
            <LoadingPlaceholder
                width={32}
                height={32}
            />
        </div>

        <div className={styles.SellerCard__info}>
            <div className={styles.SellerCard__firstLine}>
                <span className={styles.SellerCard__usernameAndProducts}>
                    <LoadingPlaceholder width={100} />
                </span>

                <span className={styles.SellerCard__reviews}>
                    <LoadingPlaceholder width={80} />
                </span>
            </div>

            <span className={styles.SellerCard__location}>
                <LoadingPlaceholder width={80} />
            </span>
        </div>
    </Panel>
);
